import axios from "axios";

/**
 * Clients for the Transaction Signing Demo.
 *  - bank: the demo bank backend on the docs server (/mock-bank), holds the API secret
 *  - p4u:  the public Passwordless4u API, called from the browser with clientId only
 * Both resolve with { status, data } instead of throwing, so pages can show refusals.
 */

const resolveAll = { validateStatus: () => true };

export const bank = axios.create({ baseURL: `${process.env.REACT_APP_MOCK_BANK_URL || ""}/mock-bank`, ...resolveAll });

let p4uClient = null;
let demoConfig = null;

export async function loadConfig() {
  if (demoConfig) return demoConfig;
  const { data } = await bank.get("/config");
  demoConfig = {
    configured: Boolean(data?.configured),
    clientId: data?.clientId || process.env.REACT_APP_DEMO_CLIENT_ID || "",
    apiUrl: process.env.REACT_APP_P4U_API_URL || data?.apiUrl || "http://localhost:3006/v1",
  };
  p4uClient = axios.create({ baseURL: demoConfig.apiUrl, ...resolveAll });
  return demoConfig;
}

export const p4u = () => {
  if (!p4uClient) throw new Error("Demo configuration not loaded yet");
  return p4uClient;
};

/** "TXN_TAMPERED: Transaction details do not match ..." from an error body */
export const errorText = (data) =>
  data ? [data.error || data.errorCode, data.errorMessage].filter(Boolean).join(": ") : "Request failed";
